import { createSelector } from "reselect";
import type { AppState } from "ee/reducers";


export const getDrawDBGroups = (state: AppState) => {
  return state.ui.drawDBApps.list;
};

export const getDrawDBApps = (state: AppState) => {
  return state.ui.drawDBApps.groupApps;
};

export const getDrawDBApp = (state: AppState) => {
  return state.ui.drawDBApps.drawDBApp;
};


export const getCurrentDrawDBGroup = (state: AppState) => {
  return state.ui.drawDBApps.currentGroup;
};

export const getIsFetchingDrawDBGroups = (state: AppState) => {
  return state.ui.drawDBApps.loadingStates.isFetchingDrawDBGroups;
};

export const getIsFetchingDrawDBApps = (state: AppState) => {
  return state.ui.drawDBApps.loadingStates.isFetchingDrawDBApps;
};

export const getIsFetchingDrawDBApp = (state: AppState) => {
  return state.ui.drawDBApps.loadingStates.isFetchingDrawDBApp;
};

export const getIsCreatingDrawDB = (state: AppState) => {
  return state.ui.drawDBApps.loadingStates.isCreatingDrawDB;
};

export const getIsImportingDrawDBApp = (state: AppState) => {
  return state.ui.drawDBApps.loadingStates.isImportingDrawDBApp;
};

export const getPermissionGroups = (state: AppState) => {
  return state.ui.drawDBApps.permissionGroups;
};

export const getGroupUsers = (state: AppState) => {
  return state.ui.drawDBApps.groupUsers;
};

